import Call from '../Call';

const PushapiConfig = {
    get() {
        return Call(`pushapiConfig`);
    },

    getAffid() {
        return Call(`pushapiConfig/affid`);
    },

    save(source) {
        return Call('pushapiConfig','POST', source);
    },

    update(id, source) {
        return Call(`pushapiConfig/${id}`,'PUT', source);
    },

    remove(id) {
        return Call(`pushapiConfig/${id}`,'DELETE');
    }
};

export default PushapiConfig;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiConfig.js